import * as Yup from 'yup'

import { PRIMARY_TEXT_LIST } from '../../../fields'
import { primaryTextItemShape } from '../../../validation'

export const primaryTextListValidation = {
  [PRIMARY_TEXT_LIST]: Yup.array().of(primaryTextItemShape)
}
